<div class="mat-margin-top mat-justify-content-center mat-align-items-center">
    <button mat-raised-button class="generateButton cancelBtn" expand="block" (click)="cancel()">Cancel</button>
    @if (!downloading) {
    <button mat-raised-button class="primary-btn generateButton" expand="block" (click)="exportReport()">
        Generate
    </button>
    }
    @if (downloading) {
    <mat-spinner class="downloadSpinner"></mat-spinner>
    }
</div>